// @flow
import React from 'react'
import { Icon, Popup } from 'semantic-ui-react'

// FIXME! - Easy - Make size and label optional and create default props
type Props = {
  size: string,
  icon: string,
  label: string,
  onClick?: any, // TODO type this properly
  className?: ?string // TODO allow multiple
}

const SocialIcon = ({ size, icon, label, onClick, className }: Props) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLSpanElement>) => {
    // Check if the Enter key was pressed (key code 13)
    if (event.keyCode === 13) {
      onClick(); // Call the onClick function when Enter is pressed
    }
  }
  return (
    <Popup
      position="top right"
      size="tiny"
      content={label}
      trigger={
        <Icon
          onClick={onClick}
          as="span"
          size={size}
          name={icon}
          aria-hidden="false"
          aria-label="social button"
          aria-haspopup="true"
          tabIndex={0}
          role="button"
          className={className || 'socialIcon'}
          onKeyDown={handleKeyDown}
        />
      }
    />
  )
}

SocialIcon.defaultProps = {
  size: 'large',
  onClick: null,
  className: null
}

export default SocialIcon



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/FlyerDetailMenu/components/SocialIcon.js